import React, { useEffect, useState } from "react";
import { useNavigate, Link, useLocation, useSearchParams } from "react-router-dom";
import axios from "axios";
import Header from "../components/Header";
import { ChevronDown, ChevronsDown, Lock, Eye, EyeOff } from "lucide-react";
import { toast } from "react-toastify";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { passwordClipboardProps } from "../utils/passwordClipboard";


const Signup = () => {
  const navigate = useNavigate();

  // const location = useLocation();
  // const isJoinUs = location.state?.fromJoinUs || false;

  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get("ref");
  // const isReferral = !!referralCode;
  const [referralValid, setReferralValid] = useState(false);
  const [referralLoading, setReferralLoading] = useState(false);
  console.log("Referral Code:", referralCode);

  const [otherCompany, setOtherCompany] = useState("");
  const [otherSector, setOtherSector] = useState("");
  const [otherIndustry, setOtherIndustry] = useState("");
  const [otherCountry, setOtherCountry] = useState("");

  const [companyValue, setCompanyValue] = useState([]);
  const [sectorValue, setSectorValue] = useState([]);
  const [industryValue, setIndustryValue] = useState([]);
  const [countryValue, setCountryValue] = useState([]);


  const [formData, setFormData] = useState({
    name: "",
    email: "",
    linkedin: "",
    companyname: "",
    countries: "", // Added countries field
    sectorname: "",
    industryname: "", // Added industryname field
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [industry, setIndustry] = useState([]);
  const [sector, setSector] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [countries, setCountries] = useState([]);

  // const [agreetoConditions, setAgreetoConditions] = useState(false);
  // const handleCheckboxChange = (e) => {
  // setAgreetoConditions(e.target.checked);
  // };


  const companyOptions = companies.map((item) => ({
    value: item.company_id,
    label: item.company_name,
  }));

  const sectorOptions = sector.map((item) => ({
    value: item.question_answer_id,
    label: item.answer,
  }));

  const industryOptions = industry.map((item) => ({
    value: item.question_answer_id,
    label: item.answer,
  }));

  const countryOptions = countries.map((item) => ({
    value: item.id,
    label: item.country_name,
  }));



  const getSectories = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/survey/sectors`,
        {
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );


      if (response.status === 200) {
        setSector(response.data.data);
        console.log("Sectors set in state:", response.data.data);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      // console.error("Error fetching sectors:", error);
      console.log("Full Error", error);
      console.log("Response", error.response);
      console.log("Status", error.response?.status);
      console.log("Data", error.response?.data);
    }
  };

  const getIndustries = async (sectorId) => {
    console.log("Selected Sector ID:", sectorId);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/survey/industries`,
        {
          sector_id: sectorId
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Industry API Response:", response.data);


      if (response.status === 200) {
        setIndustry(response.data.data);
        console.log("Industries set in state:", response.data.data);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      // console.error("Error fetching industries:", error);
      console.log("Full Error", error);
      console.log("Response", error.response);
      console.log("Status", error.response?.status);
      console.log("Data", error.response?.data);
    }
  };

  const getCompanyies = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/company/fetch-companyNames`,
        {
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );


      if (response.status === 200) {
        setCompanies(response.data.data);
        console.log("Companies set in state:", response.data.data);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      // console.error("Error fetching companies:", error);
      console.log("Full Error", error);
      console.log("Response", error.response);
      console.log("Status", error.response?.status);
      console.log("Data", error.response?.data);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/survey/countries`,
        {
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Countries API Response:", response.data);


      if (response.status === 200) {
        setCountries(response.data.data);
        console.log("Countries set in state:", response.data.data);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      // console.error("Error fetching countries:", error);
      console.log("Full Error", error);
      console.log("Response", error.response);
      console.log("Status", error.response?.status);
      console.log("Data", error.response?.data);
    }
  };


  const checkReferral = async (code) => {
    try {
      setReferralLoading(true);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/check-referral`,
        {
          referral_code: code,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.valid) {
        setReferralValid(true);
      } else {
        setReferralValid(false);
        setError(response.data.message || "Invalid referral code");
      }
    } catch (error) {
      setReferralValid(false);

      if (error.response?.status === 400) {
        // setError(error.response.data.message);
        toast.error(error.response.data.message);
      } else if (error.response?.status === 500) {
        toast.error("Server Error");
      } else {
        toast.error("Invalid referral code 2");
      }
    } finally {
      setReferralLoading(false);
    }
  };


  useEffect(() => {
    getSectories();
    getCompanyies();
    fetchCountries();
  }, []);


  // SingleSelect
  useEffect(() => {
    if (formData.sectorname) {
      getIndustries(formData.sectorname);
    }
  }, [formData.sectorname]);


  // MULTISELECT
  // useEffect(() => {
  //   if (formData.sectorname.length > 0) {
  //     getIndustries(formData.sectorname);
  //   } else {
  //     setIndustry([]);
  //   }
  // }, [formData.sectorname]);


  // useEffect(() => {
  //   if (referralCode) {
  //     checkReferral(referralCode);
  //   }
  // }, [referralCode]);

  useEffect(() => {
    if (referralCode) {
      checkReferral(referralCode);
    } else {
      setReferralValid(false);

      // Optional: form reset
      setCompanyValue(null);
      setCountryValue(null);
      setSectorValue(null);
      setIndustryValue(null);

      setFormData((prev) => ({
        ...prev,
        companyname: "",
        countries: "",
        sectorname: "",
        industryname: "",
        password: "",
        confirmPassword: "",
      }));
    }
  }, [referralCode]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((current) => ({ ...current, [name]: value }));
    setFieldErrors((current) => ({ ...current, [name]: "" }));
    setError("");
  };

  const clearFieldError = (field) => {
    setFieldErrors((current) => ({ ...current, [field]: "" }));
    setError("");
  };

  const validateForm = () => {
    const nextErrors = {};
    const name = formData.name.trim();
    const email = formData.email.trim();
    const linkedin = formData.linkedin.trim();

    if (!name) nextErrors.name = "Your name is required.";
    else if (name.length < 5 || name.length > 50) nextErrors.name = "Name must be between 5 and 50 characters.";
    else if (!/^[A-Za-z\s'-]+$/.test(name)) nextErrors.name = "Enter a name using letters only.";

    if (!email) nextErrors.email = "Email address is required.";
    else if (email.length < 5 || email.length > 50) nextErrors.email = "Email must be between 5 and 50 characters.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) nextErrors.email = "Enter a valid email address.";

    if (referralValid) {
      if (!formData.companyname && !otherCompany.trim()) nextErrors.companyname = "Select or enter a company.";
      if (!formData.countries && !otherCountry.trim()) nextErrors.countries = "Select or enter a country.";
      if (!formData.sectorname && !otherSector.trim()) nextErrors.sectorname = "Select or enter a sector.";
      if (!formData.industryname && !otherIndustry.trim()) nextErrors.industryname = "Select or enter an industry.";
      if (!formData.password) nextErrors.password = "Password is required.";
      else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(formData.password)) {
        nextErrors.password = "Use at least 8 characters with uppercase, lowercase, a number, and a symbol.";
      }
      if (!formData.confirmPassword) nextErrors.confirmPassword = "Confirm your password.";
      else if (formData.password !== formData.confirmPassword) nextErrors.confirmPassword = "Passwords do not match.";
    } else if (!linkedin) {
      nextErrors.linkedin = "LinkedIn profile is required.";
    } else if (linkedin.length < 5 || linkedin.length > 50) {
      nextErrors.linkedin = "LinkedIn link must be between 5 and 50 characters.";
    } else {
      try {
        const url = new URL(linkedin);
        if (url.protocol !== "https:" || !["linkedin.com", "www.linkedin.com"].includes(url.hostname.toLowerCase()) || !/^\/in\/[^/]+\/?$/.test(url.pathname)) {
          nextErrors.linkedin = "Enter a valid LinkedIn profile link (https://www.linkedin.com/in/...).";
        }
      } catch {
        nextErrors.linkedin = "Enter a valid LinkedIn profile link (https://www.linkedin.com/in/...).";
      }
    }

    return nextErrors;
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length) {
      setFieldErrors(validationErrors);
      setError("");
      toast.warn(Object.values(validationErrors)[0], { toastId: "signup-validation" });
      requestAnimationFrame(() => {
        document.querySelector(".signup-field-error")?.scrollIntoView({ behavior: "smooth", block: "center" });
      });
      return;
    }

    setLoading(true);
    setError("");

    try {
      let apiUrl = "";
      let requestData = {};

      const selectedCountry = countries.find(
        (item) => item.id == formData.countries
      );

      const selectedSector = sector.find(
        (item) => item.question_answer_id == formData.sectorname
      );

      const selectedIndustry = industry.find(
        (item) => item.question_answer_id == formData.industryname
      );



      if (referralValid) {

        apiUrl = `${process.env.REACT_APP_API_URL}/api/user/signup`;

        requestData = {
          name: formData.name,
          email: formData.email,
          password: formData.password,

          company_name: formData.companyname,
          other_company: otherCompany,

          sector: formData.sectorname,
          other_sector: otherSector,

          industry: formData.industryname,
          other_industry: otherIndustry,

          country: formData.countries,
          other_country: otherCountry,

          referral_code: referralCode,
        };

      } else {
        apiUrl = `${process.env.REACT_APP_API_URL}/api/user/signup-request`;

        requestData = {
          full_name: formData.name.trim(),
          email: formData.email.trim(),
          // company_name: formData.companyname,
          linkedin: formData.linkedin.trim(),
          // industry: selectedIndustry?.answer || "",
          // country: formData.countries,
        };

      }

      const response = await axios.post(apiUrl, requestData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log(response.data);

      navigate("/login", {
        state: {
          successMessage: "Signup Successful!",
        },
      });
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Unable to submit your signup request. Please try again.",
        { toastId: "signup-submit-error" }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <Header /> */}
      <div id="wrapper">
        <section className="signup-section d-flex align-items-center py-5 py-md-0">
          <div className="container signup-container">
            <div className="row">
              <div className="col-md-6 text-white d-flex align-items-center pe-md-5">
                <div className="pe-md-5 text-center text-md-start w-100">
                  {/* <p className="testwhite40 ft-20 lh-27 inter mb-4">Your are invited</p> */}
                  <h1 className="fw-bold mb-4">Apply for Membership - I&P</h1>
                  <p className="testwhite40 ft-18 lh-27 inter">Become part of a trusted community of industry professionals. Complete the required details, and our team will review your application. Once approved, your membership will be activated and you'll be ready to participate in surveys, industry insights, and rewarding opportunities.</p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-container mt-5 mt-md-0">
                  <h2 className="ft-28 fw-bold mb-1 textred">Sign Up</h2>
                  <p className="color858c95 ft-14 lh-27 inter">Please complete your detail to continue</p>

                  {error && <p className="text-danger">{error}</p>}

                  <form onSubmit={handleSubmit} noValidate>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder=" "
                        value={formData.name}
                        onChange={handleChange}
                        minLength={5}
                        maxLength={50}
                        required
                      />
                      <label htmlFor="name">Your Name</label>
                      {fieldErrors.name && <p className="signup-field-error">{fieldErrors.name}</p>}
                    </div>

                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder=" "
                        value={formData.email}
                        onChange={handleChange}
                        minLength={5}
                        maxLength={50}
                        required
                      />
                      <label htmlFor="email">Email Address</label>
                      {fieldErrors.email && <p className="signup-field-error">{fieldErrors.email}</p>}
                    </div>

                    {(!referralCode || !referralValid) && (
                      <div className="form-group">
                        <input
                          type="url"
                          className="form-control"
                          id="linkedin"
                          name="linkedin"
                          placeholder=" "
                          value={formData.linkedin}
                          onChange={handleChange}
                          minLength={5}
                          maxLength={50}
                          required
                        />
                        <label htmlFor="linkedin">Linkedin</label>
                        {fieldErrors.linkedin && <p className="signup-field-error">{fieldErrors.linkedin}</p>}
                      </div>
                    )}
                    {referralValid && referralValid && (
                      <>
                        <div className="d-flex flex-wrap gap-2 referralvalidbox">
                          <div className="form-group" style={{ flex: "0 0 calc(50% - 0.25rem)" }}>
                            <CreatableSelect
                              // isMulti
                              options={companyOptions}
                              value={companyValue}
                              formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                              createOptionPosition="first"

                              onChange={(selected) => {
                                clearFieldError("companyname");
                                setCompanyValue(selected);

                                const isExisting = companyOptions.some(
                                  (item) => item.value === selected?.value
                                );

                                setFormData((prev) => ({
                                  ...prev,
                                  companyname: isExisting ? selected.value : "",
                                }));

                                setOtherCompany(isExisting ? "" : selected?.value || "");
                              }}


                              placeholder="Select Company"
                              className="custom-react-select"

                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                              }}
                            />
                            {fieldErrors.companyname && <p className="signup-field-error">{fieldErrors.companyname}</p>}

                            {/* <label htmlFor="companyname">Company</label>

                              <ChevronDown
                                  size={18}
                                  className="custom-select-icon"
                              /> */}
                          </div>

                          <div className="form-group" style={{ flex: "0 0 calc(50% - 0.25rem)" }}>

                            <CreatableSelect
                              // isMulti
                              options={countryOptions}
                              value={countryValue}
                              formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                              createOptionPosition="first"

                              // onChange={(selected) => {
                              //   // setStates([]);

                              //   setFormData((prev) => ({
                              //     ...prev,
                              //     countries: selected ? selected.map((item) => item.value) : [],
                              //     state: [],
                              //   }));
                              // }}

                              onChange={(selected) => {
                                clearFieldError("countries");
                                setCountryValue(selected);

                                const isExisting = countryOptions.some(
                                  (item) => item.value === selected?.value
                                );

                                setFormData((prev) => ({
                                  ...prev,
                                  countries: isExisting ? selected.value : "",
                                }));

                                setOtherCountry(isExisting ? "" : selected?.value || "");
                              }}

                              placeholder="Select Country"
                              className="custom-react-select"

                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                              }}
                            />
                            {fieldErrors.countries && <p className="signup-field-error">{fieldErrors.countries}</p>}

                            {/* <label htmlFor="countries" className="textgray">
                                Country
                              </label>

                              <ChevronDown
                                size={18}
                                className="custom-select-icon"
                              /> */}
                          </div>


                          {/* <div className="form-group">
                            <input
                              type="sectorname"
                              className="form-control"
                              id="sectorname"
                              name="sectorname"
                              placeholder=" "
                              value={formData.sectorname}
                              onChange={handleChange}
                              required
                            />
                            <label htmlFor="sectorname">Industry</label>
                          </div> */}


                          <div className="form-group !tw-mb-0" style={{ flex: "0 0 calc(50% - 0.25rem)" }}>
                            <CreatableSelect
                              // isMulti
                              options={sectorOptions}
                              value={sectorValue}
                              formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                              createOptionPosition="first"

                              onChange={(selected) => {
                                clearFieldError("sectorname");
                                setSectorValue(selected);

                                const isExisting = sectorOptions.some(
                                  (item) => item.value === selected?.value
                                );

                                setFormData((prev) => ({
                                  ...prev,
                                  sectorname: isExisting ? selected.value : "",
                                  industryname: "",
                                }));

                                setIndustryValue(null);

                                if (selected && isExisting) {
                                  getIndustries(selected.value);
                                } else {
                                  setIndustry([]);
                                }

                                setOtherSector(isExisting ? "" : selected?.value || "");
                              }}


                              placeholder="Select Sector"
                              className="custom-react-select"

                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                              }}
                            />
                            {fieldErrors.sectorname && <p className="signup-field-error">{fieldErrors.sectorname}</p>}

                            {/* <label htmlFor="sectorname" className="textgray">
                              Sector
                            </label>

                            <ChevronDown
                              size={18}
                              className="custom-select-icon"
                            /> */}
                          </div>

                          <div className="form-group !tw-mb-0" style={{ flex: "0 0 calc(50% - 0.25rem)" }}>
                            <CreatableSelect
                              // isMulti
                              options={industryOptions}
                              value={industryValue}
                              formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                              createOptionPosition="first"

                              // onChange={(selected) =>
                              //   setFormData(prev => ({
                              //     ...prev,
                              //     industryname: selected ? selected.map(item => item.value) : [],
                              //   }))
                              // }

                              onChange={(selected) => {
                                clearFieldError("industryname");
                                setIndustryValue(selected);

                                const isExisting = industryOptions.some(
                                  (item) => item.value === selected?.value
                                );

                                setFormData((prev) => ({
                                  ...prev,
                                  industryname: isExisting ? selected.value : "",
                                }));

                                setOtherIndustry(isExisting ? "" : selected?.value || "");
                              }}

                              placeholder="Select Industry"
                              className="custom-react-select"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                              }}
                            // isDisabled={formData.sectorname.length === 0}
                            />
                            {fieldErrors.industryname && <p className="signup-field-error">{fieldErrors.industryname}</p>}

                            {/* <label htmlFor="industryname" className="textgray">
                                Industry
                              </label>

                              <ChevronDown
                                size={18} 
                                className="custom-select-icon"
                              /> */}
                          </div>


                        </div>

                        {/* Password Field */}
                        <div className="form-group">
                          <input
                            type={showPassword ? "text" : "password"}
                            className={`form-control password-with-toggle ${formData.password ? "has-value" : ""}`}
                            id="password"
                            name="password"
                            autoComplete="new-password"
                            placeholder=" "
                            value={formData.password}
                            onChange={handleChange}
                            {...passwordClipboardProps}
                            required
                          />
                          <label htmlFor="password">Password</label>
                          <button type="button" className="password-visibility-toggle" aria-label={showPassword ? "Hide password" : "Show password"} aria-pressed={showPassword} onClick={() => setShowPassword((visible) => !visible)}>
                            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                          </button>
                          {fieldErrors.password && <p className="signup-field-error">{fieldErrors.password}</p>}
                        </div>

                        {/* Password Field */}
                        <div className="form-group">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            className={`form-control password-with-toggle ${formData.confirmPassword ? "has-value" : ""}`}
                            id="confirmPassword"
                            name="confirmPassword"
                            autoComplete="new-password"
                            placeholder=" "
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            {...passwordClipboardProps}
                            required
                          />
                          <label htmlFor="confirmPassword">Confirm Password</label>
                          <button type="button" className="password-visibility-toggle" aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"} aria-pressed={showConfirmPassword} onClick={() => setShowConfirmPassword((visible) => !visible)}>
                            {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                          </button>
                          {fieldErrors.confirmPassword && <p className="signup-field-error">{fieldErrors.confirmPassword}</p>}
                        </div>
                      </>
                    )}



                    {/* <div className="d-flex justify-content-between align-items-center">                      
                      <span className="stay-signed-in checkbox-container d-flex gap-3">
                        <input
                          id="persistent"
                          name="persistent"
                          type="checkbox"
                          checked={agreetoConditions}
                          onChange={handleCheckboxChange}
                        />
                        <label for="persistent">Agree to Term & Conditions</label>
                      </span>
                    </div> */}


                    {/* <button type="submit" className="btn btn-red ft-15 fw-600 w-100 my-4 py-3" disabled={loading || !agreetoConditions}>
                      {loading ? "Submitting..." : "Submit"} <i className="fa-solid fa-arrow-right ms-2"></i>
                    </button> */}


                    <div className="d-flex align-items-center gap-3 p-3 rounded" style={{ background: "#FFEFEE" }}>
                      <Lock size={22} className="textred" />
                      <span className="ft-12 fw-500 graytext">
                        We'll use this information to personalize your survey experience.
                      </span>
                    </div>

                    <button type="submit" className="btn btn-red ft-15 fw-600 w-100 my-4 py-3" disabled={loading || referralLoading}>
                      {loading ? "Submitting..." : "Submit"} <i className="fa-solid fa-arrow-right ms-2"></i>
                    </button>

                    <p className="mt-3 ft-14 lh-24 text-center">
                      By continuing, you agree to our {" "}
                      <Link
                        to="/terms-and-conditions"
                        className="login-link pr-2 textred"
                        style={{ textDecoration: "none" }}
                      >
                        Terms & Conditions
                      </Link>

                      <span className="px-1">and</span>

                      <Link
                        to="/privacy-policy"
                        className="login-link pl-2 textred"
                        style={{ textDecoration: "none" }}
                      >
                        Privacy Policy.
                      </Link>
                    </p>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Signup;
